import React, { memo } from 'react';

import useThrottleInstallGameClick from 'hooks/useThrottleInstallGameClick';
import ButtonLink from 'components/button-link';
import Image from 'components/image';
import Video from 'components/video';
import { getOSByUA } from 'utils';
import { OS, TGame } from 'types';
import './styles.scss';

interface IGame {
  game: TGame;
  compact?: boolean;
  aboveParent?: boolean;
  aboveInstall?: boolean;
  className?: string;
  selected?: boolean;
  main?: boolean;
  onClick?: (game: TGame) => void;
}

const Game: React.FC<IGame> = ({
  game,
  className,
  compact ,
  aboveParent,
  aboveInstall,
  selected,
  main,
  onClick,
}) => {
  // Need to figure out OS of the device. If there is no poster, only on Android devices browser shows default play
  // button on videos, therefore on Android devices we will add transparent poster.
  const deviceOS = getOSByUA();
  const onInstallGame = useThrottleInstallGameClick(game);

  const handleClick = () => {
    if (onClick) {
      onClick(game);
    } else {
      // By default, use direct click to the store.
      onInstallGame();
    }
  };

  return (
    <div
      className={[
        'game-container flex flex-col justify-between',
        className,
        compact ? 'compact' : false,
        aboveParent ? 'above-parent' : false,
        aboveInstall ? 'above-install' : false,
        main ? 'main' : false,
      ].filter(Boolean).join(' ')}
    >
      <div className={`flex ${aboveParent ? 'items-center' : 'flex-col'}`}>
        {aboveInstall && selected && game.videoShort ? (
          <Video
            muted
            autoRepeat
            forceClick
            autoPlayInView
            hideVolumeControls
            withControls={false}
            url={game.videoShort}
            inViewThreshold={0.9}
            transparentPoster={deviceOS === OS.android}
            handleClick={handleClick}
          />
        ) : (
          <Image src={game.logoURL} onClick={handleClick} />
        )}
        <div className="game">
          <ButtonLink className="game-name" onClick={handleClick}>{game.name}</ButtonLink>
          {(game.title && compact) && <div className="game-title">{game.title}</div>}
          <div className="game-rating">★<span>{game.rating.toFixed(1)}</span></div>
        </div>
      </div>
      {(aboveParent || (aboveInstall && selected)) && (
        <ButtonLink className="install-game-btn" onClick={onInstallGame}>Get</ButtonLink>
      )}
    </div>
  );
};

export default memo(Game);
